export const videoTypes = ['.MOV', '.mp4'];
export const s3APIUrl = process.env.S3_API_URL || 'https://yangsmartialart.net/api/';
export const s3BucketUrl = process.env.S3_BUCKET_URL || 'https://yangsmartialart.net/';
export const ymasAPIUrl = process.env.S3_API_URL || 'https://apis.yangsmartialart.net/';

export * from './routes';
export * from './yangs';